// extracted by mini-css-extract-plugin
module.exports = {"comment-popover":"styles_comment-popover__3TQfL","comment-feedback-loader":"styles_comment-feedback-loader__2xH22"};